
 <!-- 铺位租控 -->
<template>
  <div class="shop-control-container">
    <!-- 1. 顶部汇总统计卡片 -->
    <div class="summary-row">
      <div
        v-for="(item, index) in summaryCards"
        :key="index"
        class="summary-card"
      >
        <div class="summary-label">{{ item.label }}</div>
        <div class="summary-value" :style="{ color: item.color }">
          {{ item.value }} <span class="arrow">个</span>
        </div>
      </div>
    </div>

    <!-- 2. 筛选区域 -->
    <div class="filter-section">
      <div class="filter-item">
        <span class="label">选择区域：</span>
        <el-select
          v-model="currentAsset"
          size="small"
          placeholder="请选择"
          style="width: 200px"
          @change="assetChange"
        >
          <el-option
            v-for="item in assetList"
            :label="item.assetName"
            :value="item.assetId"
            :key="item.assetId"
          />
        </el-select>
      </div>
    </div>

    <!-- 3. 图例说明 -->
    <div class="legend-bar">
      <span class="legend-title">图例：</span>
      <div v-for="lg in legendItems" :key="lg.label" class="legend-item">
        <span
          class="color-box"
          :style="{
            backgroundColor: lg.bg,
            borderColor: lg.border || 'transparent',
            borderStyle: lg.border ? 'solid' : 'none',
            borderWidth: '1px',
          }"
        ></span>
        <span class="text">{{ lg.label }}</span>
      </div>
    </div>

    <!-- 4. 铺位方块群 (宽度铺满) -->
    <div class="shop-grid-wrapper">
      <div class="shop-grid">
        <div
          v-for="item in resourceListZK"
          :key="item.resourceId"
          class="shop-box"
          :class="['status-' + item.currentStatus]"
        >
          <div class="shop-name">{{ item.resourceName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { formatDate } from "../../../utils/dateUtil.js";
import {
  mapValuesToArray,
  commonFormatter,
  safeDivide,
  filterEmptyFields,
} from "../../../utils/tool.js";

const TAG = "铺位租控";

export default {
  data() {
    return {
      // 当前选中的区域
      currentAsset: "",
      // 顶部汇总统计
      summaryCards: [
        {
          label: "总铺位数",
          value: "",
          unit: "个",
          color: "#409EFF",
          key: "totalCount",
        },
        {
          label: "已出租",
          value: "",
          unit: "个",
          color: "#67C23A",
          key: "rentedCount",
        },
        {
          label: "空置可租",
          value: "",
          unit: "个",
          color: "#E6A23C",
          key: "availableCount",
        },
        {
          label: "已预订",
          value: "",
          unit: "个",
          color: "#409EFF",
          key: "reservedCount",
        },
        {
          label: "即将到期",
          value: "",
          unit: "个",
          color: "#F56C6C",
          key: "expiringCount",
        },
      ],

      // 图例配置
      legendItems: [
        { label: "已出租", bg: "#52c41a" },
        { label: "空置可租", bg: "#ffffff", border: "#d9d9d9" },
        { label: "已预订", bg: "#ffffff", border: "#1890ff" },
        { label: "装修中", bg: "#722ed1" },
        { label: "即将到期", bg: "#ff4d4f" },
      ],
    };
  },

  computed: {
    ...mapState("asset", ["assetList", "resourceListZK"]),
  },

  mounted() {
    this.search();
    this.searchStatics();
  },
  methods: {
    ...mapActions("asset", [
      "listWithAssetHandler", // 租控图，车位，广告位，铺位
      "getStatisticsHandler", // 租控图，车位，广告位，铺位
    ]),

    search() {
      const params = {
        resourceType: "SHOPPING_MALL",
        assetId: this.currentAsset,
      };
      const noEmptyParams = filterEmptyFields(params);
      this.listWithAssetHandler(noEmptyParams).then((res) => {
        this.currentAsset = _.get(this.assetList, "[0].assetId");
        console.log(TAG, "init this.currentAsset=", this.currentAsset);
        console.log(TAG, "init this.resourceListZK=", this.resourceListZK);
      });
    },

    searchStatics() {
      const params = { resourceType: "SHOPPING_MALL" };
      this.getStatisticsHandler(params).then((obj) => {
        this.summaryCards = mapValuesToArray(this.summaryCards, obj);
        console.log(TAG, "init this.summaryCards=", this.summaryCards);
      });
    },

    assetChange() {
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$bg-page: #f0f2f5; // 页面整体底色
$bg-white: #ffffff; // 通用白色背景
$border-color: #ebeef5; // 容器边框色
$text-sub: #909399; // 次要文本颜色
$text-main: #303133; // 主文本颜色

/* 状态专用色 */
$color-rented: #52c41a; // 已出租 (绿)
$color-decorating: #722ed1; // 装修中 (紫)
$color-vacant-border: #dcdfe6; // 空置边框 (灰)
$color-reserved-border: #1890ff; // 已预订边框 (蓝)

$color-green: #52c41a; // 已出租-绿
$color-red: #ff4d4f; // 即将到期-红
$color-blue: #1890ff; // 已预订-蓝
$color-white: #fff; // 空闲-白色
$color-purple: #722ed1; // 装修中 (紫色)
$color-vacant-border: #dcdfe6; // 空置边框
$vacant-border: #dcdfe6; // 空置边框

.shop-control-container {
  /* 顶部汇总卡片布局 */
  .summary-row {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    flex-wrap: wrap;

    .summary-card {
      flex: 1;
      min-width: 200px;
      background: $bg-white;
      padding: 15px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .summary-label {
        font-size: 13px;
        color: $text-sub;
        margin-bottom: 8px;
      }
      .summary-value {
        font-size: 22px;
        font-weight: 500;
        .arrow {
          font-size: 16px;
          margin-left: 2px;
        }
      }
    }
  }

  /* 筛选工具栏 */
  .filter-section {
    background: $bg-white;
    padding: 12px 20px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid $border-color;
    text-align: left;
    .label {
      font-size: 14px;
      font-weight: bold;
      color: $text-main;
    }
  }

  /* 图例栏 */
  .legend-bar {
    background: $bg-white;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    border-bottom: 1px solid $border-color;

    .legend-title {
      font-size: 13px;
      font-weight: bold;
    }
    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;
      .color-box {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        display: inline-block;
      }
      .text {
        font-size: 12px;
        color: $text-main;
      }
    }
  }

  /* 铺位主网格容器 */
  .shop-grid-wrapper {
    background: $bg-white;
    padding: 24px;
    border-radius: 0 0 4px 4px;
    min-height: calc(100vh - 460px);

    .shop-grid {
      display: grid;
      // 还原图片中的一排 6 列布局
      grid-template-columns: repeat(6, 1fr);
      gap: 12px;
      width: 100%;
    }
  }

  /* 铺位单项样式 */
  .shop-box {
    height: 60px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid transparent;

    .shop-name {
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .shop-status-text {
      font-size: 10px;
    }

    /* 状态样式 */
    // 已出租
    &.status-RENTED {
      background-color: $color-green;
      color: #fff;
    }

    // 即将到期
    &.status-expiring {
      background-color: $color-red;
      color: #fff;
    }

    // 已预定
    &.status-RESERVED {
      background-color: #fff;
      border: 1px solid $color-blue;
      color: black;
    }

    // 装修中
    &.status-RENOVATING {
      background-color: $color-purple;
      border: 1px solid $color-purple;
      color: $color-white;
    }

    // 空闲可租
    &.status-AVAILABLE {
      background-color: $color-white;
      border: 1px solid $vacant-border;
      color: #999;
      .park-code {
        color: #555;
      }
    }

    &:hover {
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
    }
  }
}

/* 响应式适配 */
@media screen and (max-width: 1400px) {
  .shop-control-container .shop-grid-wrapper .shop-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media screen and (max-width: 1100px) {
  .shop-control-container .summary-row .summary-card {
    min-width: 150px;
  }
  .shop-control-container .shop-grid-wrapper .shop-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .shop-control-container .shop-grid-wrapper .shop-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>